import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';

class PaymentServicesClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }
}

export const PaymentService = new PaymentServicesClass({
  api_version: 2,
  resource: 'payments'
});
